<script setup lang="ts">
import type { SignUpCallbackType } from '@mixins'
import type { FirebaseTokenStatus } from '@firebaseModule'
import { FirebaseDevice } from '@store'

definePageMeta({
  layout: 'call-back',
})

useSetSEO()

const route = useRoute()
const { sender } = usePostMessage()
const { cookieNames, getCookie } = useCookies()

onBeforeMount(() => {
  const fcmTokenStatus = getCookie<FirebaseTokenStatus>(
    cookieNames.FCM_TOKEN_STATUS
  ) || {
    fcmDevice: FirebaseDevice.WEB,
    fcmAppToken: '',
    fcmWebToken: '',
  }

  const payload: SignUpCallbackType = {
    fcmDevice: fcmTokenStatus.fcmDevice,
    userCmmnSn: Number(route.query.userCmmnSn),
    autoLogin: route.query.autoLogin === 'true',
  }

  // 레퍼럴 추천인
  if (route.query.referral && route.query.referral !== 'null') {
    payload.referralCode = String(route.query.referral)
  }

  // 일반 추천인
  if (route.query.recommender && route.query.recommender !== 'null') {
    payload.recommenderId = String(route.query.recommender)
  }

  // 제휴사 코드
  if (route.query.recomendAffltsId && route.query.recomendAffltsId !== 'null') {
    payload.recomendAffltsId = String(route.query.recomendAffltsId)
    payload.recomendAffltsSbscrbAt = 'Y'
  }

  sender(
    'opener',
    {
      res: payload,
      type: 'signup',
    },
    true
  )
})
</script>

<template>
  <NovaLoadingIndicator :bg-bright="'light'" :fill="true" />
</template>
